import { v4 as uuid } from 'uuid';
export const VideoIntelligenceData = [
  {
    image: 'Sanjeev Kumar',
    type: 'People',
    mainID: uuid(),
    AssetIds: ['f29671e1-d85f-4627-a422-9e2b06781cc8'],
    imageSrc:
      'https://res.cloudinary.com/drvaemi9t/image/upload/v1656934444/Sanjeev_Kumar_jtr4f9.jpg',
    info: [
      {
        id: 'c8e9cdce-78c5-43c9-bf95-ef942e561278', //Khilona;
        duration: '04:29',
        ts: [
          { start: '00:19', end: '00:56' },
          { start: '0:57', end: '01:07' },
          { start: '01:09', end: '01:10' },
          { start: '01:14', end: '01:19' },
          { start: '01:19', end: '01:27' },
          { start: '01:27', end: '01:29' },
          { start: '01:29', end: '01:49' },
          { start: '02:03', end: '02:07' },
          { start: '02:28', end: '02:31' },
          { start: '02:40', end: '03:13' },
          { start: '02:20', end: '03:46' },
          { start: '03:58', end: '04:01' },
        ],
      },
    ],
  },
  {
    image: 'Jayshree Talpade',
    imageSrc:
      'https://res.cloudinary.com/drvaemi9t/image/upload/v1656934444/Jayshree_Talpade_ohgtjm.jpg',
    type: 'People',
    mainID: uuid(),
    AssetIds: ['c8e9cdce-78c5-43c9-bf95-ef942e561278'],

    info: [
      {
        id: 'c8e9cdce-78c5-43c9-bf95-ef942e561278', //Khilona;
        duration: '04:29',
        ts: [
          { start: '00:12', end: '00:19' },
          { start: '00:57', end: '01:07' },
          { start: '01:07', end: '01:09' },
          { start: '01:10', end: '01:13' },
          { start: '01:14', end: '01:19' },
          { start: '01:27', end: '01:29' },
          { start: '01:50', end: '02:02' },
          { start: '02:08', end: '02:10' },
          { start: '02:13', end: '02:28' },
          { start: '02:28', end: '02:31' },
          { start: '02:40', end: '03:13' },
          { start: '03:16', end: '03:20' },
          { start: '03:46', end: '03:58' },
          { start: '04:10', end: '04:14' },
        ],
      },
    ],
  },
  {
    image: 'Jeetendra',
    type: 'People',
    mainID: uuid(),
    AssetIds: [
      'b9580c20-4c77-46ff-88ca-9846ef9d8bf5',
      '84466189-6013-4b36-92cd-8b44f597c8fd',
      'cfdf128c-3ea6-4cab-a47b-f529c8b9887c',
      '502086d6-989a-4b9e-a40f-35d7efa33aaa',
      '6b7c9d0d-97a4-4c40-81ec-08c7235cb331',
      'dea37a6d-a712-42d6-8c6f-50f4c161ab16',
    ],
    imageSrc:
      'https://res.cloudinary.com/drvaemi9t/image/upload/v1656910392/Jeetendra_iuino4.jpg',
    info: [
      {
        id: 'b9580c20-4c77-46ff-88ca-9846ef9d8bf5', //Shaadi Ke Baad;
        duration: '5:08',
        ts: [
          { start: '00:36', end: '00:50' },
          { start: '00:59', end: '01:12' },
          { start: '01:12', end: '01:16' },
          { start: '02:24', end: '02:43' },
          { start: '03:05', end: '03:22' },
        ],
      },
      {
        id: '84466189-6013-4b36-92cd-8b44f597c8fd', //Shaadi Ke Baad;
        duration: '5:08',
        ts: [
          { start: '00:36', end: '00:50' },
          { start: '00:59', end: '01:12' },
          { start: '01:12', end: '01:16' },
          { start: '02:24', end: '02:43' },
          { start: '03:05', end: '03:22' },
        ],
      },
      {
        id: 'cfdf128c-3ea6-4cab-a47b-f529c8b9887c', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:00', end: '00:37' },
          { start: '00:42', end: '00:44' },
          { start: '00:45', end: '00:57' },
          { start: '01:12', end: '01:16' },
          { start: '01:25', end: '01:57' },
          { start: '02:02', end: '02:16' },
          { start: '02:21', end: '02:24' },
          { start: '02:27', end: '02:28' },
          { start: '02:41', end: '02:45' },
          { start: '02:45', end: '03:01' },
          { start: '03:01', end: '03:11' },
          { start: '03:20', end: '03:28' },
        ],
      },
      {
        id: '502086d6-989a-4b9e-a40f-35d7efa33aaa',
        duration: '3:37',
        ts: [
          { start: '00:12', end: '00:26' },
          { start: '0:26', end: '00:48' },
          { start: '00:57', end: '01:07' },
          { start: '01:12', end: '01:15' },
          { start: '01:19', end: '01:20' },
          { start: '01:23', end: '01:30' },
          { start: '01:30', end: '01:33' },
          { start: '01:34', end: '01:36' },
          { start: '01:36', end: '01:42' },
          { start: '01:43', end: '02:09' },
          { start: '02:14', end: '02:30' },
          { start: '02:33', end: '02:35' },
          { start: '02:35', end: '02:37' },
          { start: '02:39', end: '02:41' },
          { start: '02:53', end: '02:57' },
          { start: '02:57', end: '03:15' },
          { start: '03:14', end: '03:18' },
          { start: '03:18', end: '03:23' },
          { start: '03:24', end: '03:30' },
          { start: '03:32', end: '03:47' },
        ],
      },
      {
        id: '6b7c9d0d-97a4-4c40-81ec-08c7235cb331', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:00', end: '00:37' },
          { start: '00:42', end: '00:44' },
          { start: '00:45', end: '00:57' },
          { start: '01:12', end: '01:16' },
          { start: '01:25', end: '01:57' },
          { start: '02:02', end: '02:16' },
          { start: '02:21', end: '02:24' },
          { start: '02:27', end: '02:28' },
          { start: '02:41', end: '02:45' },
          { start: '02:45', end: '03:01' },
          { start: '03:01', end: '03:11' },
          { start: '03:20', end: '03:28' },
        ],
      },
      {
        id: 'dea37a6d-a712-42d6-8c6f-50f4c161ab16', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:00', end: '00:37' },
          { start: '00:42', end: '00:44' },
          { start: '00:45', end: '00:57' },
          { start: '01:12', end: '01:16' },
          { start: '01:25', end: '01:57' },
          { start: '02:02', end: '02:16' },
          { start: '02:21', end: '02:24' },
          { start: '02:27', end: '02:28' },
          { start: '02:41', end: '02:45' },
          { start: '02:45', end: '03:01' },
          { start: '03:01', end: '03:11' },
          { start: '03:20', end: '03:28' },
        ],
      },
    ],
  },

  {
    image: 'Rakhee Gulzar',
    type: 'People',
    mainID: uuid(),
    AssetIds: [
      'b9580c20-4c77-46ff-88ca-9846ef9d8bf5',
      '84466189-6013-4b36-92cd-8b44f597c8fd',
    ],
    imageSrc:
      'https://res.cloudinary.com/drvaemi9t/image/upload/v1656934445/Rakhee_Gulzar_ofqp4h.jpg',
    info: [
      {
        id: 'b9580c20-4c77-46ff-88ca-9846ef9d8bf5', //Shaadi Ke baad;
        duration: '5:08',
        ts: [
          { start: '00:21', end: '00:31' },
          { start: '00:31', end: '00:42' },
          { start: '00:45', end: '00:49' },
          { start: '00:54', end: '01:02' },
          { start: '01:05', end: '01:10' },
          { start: '01:15', end: '01:17' },
          { start: '01:17', end: '02:14' },
          { start: '02:19', end: '02:22' },
          { start: '02:22', end: '02:26' },
          { start: '02:30', end: '03:04' },
          { start: '03:15', end: '03:24' },
          { start: '03:25', end: '03:29' },
          { start: '03:29', end: '03:36' },
          { start: '03:40', end: '03:42' },
          { start: '03:44', end: '03:46' },
          { start: '03:46', end: '03:59' },
          { start: '04:02', end: '04:06' },
          { start: '04:10', end: '04:53' },
        ],
      },
      {
        id: '84466189-6013-4b36-92cd-8b44f597c8fd', //Shaadi Ke baad;
        duration: '5:08',
        ts: [
          { start: '00:21', end: '00:31' },
          { start: '00:31', end: '00:42' },
          { start: '00:45', end: '00:49' },
          { start: '00:54', end: '01:02' },
          { start: '01:05', end: '01:10' },
          { start: '01:15', end: '01:17' },
          { start: '01:17', end: '02:14' },
          { start: '02:19', end: '02:22' },
          { start: '02:22', end: '02:26' },
          { start: '02:30', end: '03:04' },
          { start: '03:15', end: '03:24' },
          { start: '03:25', end: '03:29' },
          { start: '03:29', end: '03:36' },
          { start: '03:40', end: '03:42' },
          { start: '03:44', end: '03:46' },
          { start: '03:46', end: '03:59' },
          { start: '04:02', end: '04:06' },
          { start: '04:10', end: '04:53' },
        ],
      },
    ],
  },

  {
    image: 'Rehman',
    type: 'People',
    mainID: uuid(),
    AssetIds: [
      'b6837c76-2c57-49e9-8574-2b5dd8dd0343',
      '75cd7166-b438-4474-8314-717800bd0d17',
    ],
    imageSrc:
      'https://res.cloudinary.com/drvaemi9t/image/upload/v1656933988/Rehman_bsom9z.jpg',
    info: [
      {
        id: 'b6837c76-2c57-49e9-8574-2b5dd8dd0343', //Chhoti Bahen;
        duration: '3:47',
        ts: [
          { start: '00:00', end: '00:36' },
          { start: '0:50', end: '00:58' },
          { start: '00:59', end: '01:12' },
          { start: '01:12', end: '01:16' },
          { start: '01:17', end: '02:24' },
          { start: '02:24', end: '02:43' },
          { start: '02:43', end: '03:05' },
          { start: '03:23', end: '03:47' },
        ],
      },
      {
        id: '75cd7166-b438-4474-8314-717800bd0d17', //Chhoti Bahen;
        duration: '3:47',
        ts: [
          { start: '00:00', end: '00:36' },
          { start: '0:50', end: '00:58' },
          { start: '00:59', end: '01:12' },
          { start: '01:12', end: '01:16' },
          { start: '01:17', end: '02:24' },
          { start: '02:24', end: '02:43' },
          { start: '02:43', end: '03:05' },
          { start: '03:23', end: '03:47' },
        ],
      },
    ],
  },

  {
    image: 'Tanuja samarth',
    type: 'People',
    mainID: uuid(),
    AssetIds: [
      'cfdf128c-3ea6-4cab-a47b-f529c8b9887c',
      '502086d6-989a-4b9e-a40f-35d7efa33aaa',
      '6b7c9d0d-97a4-4c40-81ec-08c7235cb331',
      'dea37a6d-a712-42d6-8c6f-50f4c161ab16',
      'b6837c76-2c57-49e9-8574-2b5dd8dd0343',
    ],
    imageSrc:
      'https://res.cloudinary.com/drvaemi9t/image/upload/v1656912278/Tanuja_attending_Durga_puja_in_2021_gvbxfu.jpg',
    info: [
      {
        id: 'cfdf128c-3ea6-4cab-a47b-f529c8b9887c', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:38', end: '00:42' },
          { start: '00:42', end: '00:44' },
          { start: '00:58', end: '01:08' },
          { start: '01:12', end: '01:16' },
          { start: '01:17', end: '01:21' },
          { start: '01:58', end: '02:01' },
          { start: '02:02', end: '02:16' },
          { start: '02:31', end: '02:40' },
          { start: '02:41', end: '02:45' },
          { start: '03:01', end: '03:05' },
          { start: '03:11', end: '03:19' },
          { start: '03:20', end: '03:28' },
          { start: '03:31', end: '03:36' },
        ],
      },
      {
        id: '502086d6-989a-4b9e-a40f-35d7efa33aaa', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:38', end: '00:42' },
          { start: '00:42', end: '00:44' },
          { start: '00:58', end: '01:08' },
          { start: '01:12', end: '01:16' },
          { start: '01:17', end: '01:21' },
          { start: '01:58', end: '02:01' },
          { start: '02:02', end: '02:16' },
          { start: '02:31', end: '02:40' },
          { start: '02:41', end: '02:45' },
          { start: '03:01', end: '03:05' },
          { start: '03:11', end: '03:19' },
          { start: '03:20', end: '03:28' },
          { start: '03:31', end: '03:36' },
        ],
      },
      {
        id: '6b7c9d0d-97a4-4c40-81ec-08c7235cb331', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:38', end: '00:42' },
          { start: '00:42', end: '00:44' },
          { start: '00:58', end: '01:08' },
          { start: '01:12', end: '01:16' },
          { start: '01:17', end: '01:21' },
          { start: '01:58', end: '02:01' },
          { start: '02:02', end: '02:16' },
          { start: '02:31', end: '02:40' },
          { start: '02:41', end: '02:45' },
          { start: '03:01', end: '03:05' },
          { start: '03:11', end: '03:19' },
          { start: '03:20', end: '03:28' },
          { start: '03:31', end: '03:36' },
        ],
      },
      {
        id: 'dea37a6d-a712-42d6-8c6f-50f4c161ab16', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:38', end: '00:42' },
          { start: '00:42', end: '00:44' },
          { start: '00:58', end: '01:08' },
          { start: '01:12', end: '01:16' },
          { start: '01:17', end: '01:21' },
          { start: '01:58', end: '02:01' },
          { start: '02:02', end: '02:16' },
          { start: '02:31', end: '02:40' },
          { start: '02:41', end: '02:45' },
          { start: '03:01', end: '03:05' },
          { start: '03:11', end: '03:19' },
          { start: '03:20', end: '03:28' },
          { start: '03:31', end: '03:36' },
        ],
      },
    ],
  },
  {
    image: 'Shyama',
    type: 'People',
    mainID: uuid(),
    AssetIds: [
      'b6837c76-2c57-49e9-8574-2b5dd8dd0343',
      '75cd7166-b438-4474-8314-717800bd0d17',
    ],
    imageSrc:
      'https://res.cloudinary.com/drvaemi9t/image/upload/v1657009516/Shyama_oxmkli.jpg',
    info: [
      {
        id: 'b6837c76-2c57-49e9-8574-2b5dd8dd0343', //Chhoti Bahen;
        duration: '3:47',
        ts: [
          { start: '00:36', end: '00:50' },
          { start: '00:59', end: '01:12' },
          { start: '01:12', end: '01:16' },
          { start: '02:24', end: '02:43' },
          { start: '03:05', end: '03:22' },
        ],
      },
      {
        id: '75cd7166-b438-4474-8314-717800bd0d17', //Chhoti Bahen;
        duration: '3:47',
        ts: [
          { start: '00:36', end: '00:50' },
          { start: '00:59', end: '01:12' },
          { start: '01:12', end: '01:16' },
          { start: '02:24', end: '02:43' },
          { start: '03:05', end: '03:22' },
        ],
      },
    ],
  },
  {
    image: 'Monmohan Krishna',
    type: 'People',
    mainID: uuid(),
    AssetIds: [
      'cfdf128c-3ea6-4cab-a47b-f529c8b9887c',
      '502086d6-989a-4b9e-a40f-35d7efa33aaa',
      '6b7c9d0d-97a4-4c40-81ec-08c7235cb331',
      'dea37a6d-a712-42d6-8c6f-50f4c161ab16',
    ],
    imageSrc:
      'https://res.cloudinary.com/drvaemi9t/image/upload/v1656911793/Manmohan__actor_2_b7chwz.png',
    info: [
      {
        id: 'cfdf128c-3ea6-4cab-a47b-f529c8b9887c', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '01:08', end: '01:09' },
          { start: '02:18', end: '02:20' },
          { start: '02:25', end: '02:26' },
          { start: '02:29', end: '02:30' },
        ],
      },

      {
        id: '502086d6-989a-4b9e-a40f-35d7efa33aaa',
        duration: '3:37',
        ts: [
          { start: '01:10', end: '01:11' },
          { start: '01:31', end: '01:38' },
          { start: '02:50', end: '02:53' },
          { start: '03:03', end: '03:10' },
        ],
      },
      {
        id: '6b7c9d0d-97a4-4c40-81ec-08c7235cb331', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '01:08', end: '01:09' },
          { start: '02:18', end: '02:20' },
          { start: '02:25', end: '02:26' },
          { start: '02:29', end: '02:30' },
        ],
      },
      {
        id: 'dea37a6d-a712-42d6-8c6f-50f4c161ab16', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '01:08', end: '01:09' },
          { start: '02:18', end: '02:20' },
          { start: '02:25', end: '02:26' },
          { start: '02:29', end: '02:30' },
        ],
      },
    ],
  },

  {
    image: 'Jagdeep',
    type: 'People',
    mainID: uuid(),
    AssetIds: [
      'cfdf128c-3ea6-4cab-a47b-f529c8b9887c',
      '502086d6-989a-4b9e-a40f-35d7efa33aaa',
      '6b7c9d0d-97a4-4c40-81ec-08c7235cb331',
      'dea37a6d-a712-42d6-8c6f-50f4c161ab16',
    ],
    imageSrc:
      'https://res.cloudinary.com/drvaemi9t/image/upload/v1656913060/jagdeep_krgurk.jpg',
    info: [
      {
        id: 'cfdf128c-3ea6-4cab-a47b-f529c8b9887c', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '01:01', end: '01:10' },
          { start: '01:13', end: '01:17' },
          { start: '01:35', end: '01:45' },
          { start: '01:51', end: '01:58' },
          { start: '02:17', end: '02:21' },
          { start: '02:25', end: '02:28' },
          { start: '02:29', end: '02:30' },
          { start: '02:28', end: '02:44' },
        ],
      },

      {
        id: '502086d6-989a-4b9e-a40f-35d7efa33aaa', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '01:01', end: '01:10' },
          { start: '01:13', end: '01:17' },
          { start: '01:35', end: '01:45' },
          { start: '01:51', end: '01:58' },
          { start: '02:17', end: '02:21' },
          { start: '02:25', end: '02:28' },
          { start: '02:29', end: '02:30' },
          { start: '02:28', end: '02:44' },
        ],
      },
      {
        id: '6b7c9d0d-97a4-4c40-81ec-08c7235cb331', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '01:01', end: '01:10' },
          { start: '01:13', end: '01:17' },
          { start: '01:35', end: '01:45' },
          { start: '01:51', end: '01:58' },
          { start: '02:17', end: '02:21' },
          { start: '02:25', end: '02:28' },
          { start: '02:29', end: '02:30' },
          { start: '02:28', end: '02:44' },
        ],
      },
      {
        id: 'dea37a6d-a712-42d6-8c6f-50f4c161ab16', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '01:01', end: '01:10' },
          { start: '01:13', end: '01:17' },
          { start: '01:35', end: '01:45' },
          { start: '01:51', end: '01:58' },
          { start: '02:17', end: '02:21' },
          { start: '02:25', end: '02:28' },
          { start: '02:29', end: '02:30' },
          { start: '02:28', end: '02:44' },
        ],
      },
    ],
  },

  {
    image: 'Person 1',
    type: 'People',
    mainID: uuid(),
    AssetIds: [
      'b6837c76-2c57-49e9-8574-2b5dd8dd0343',
      '75cd7166-b438-4474-8314-717800bd0d17',
    ],
    imageSrc:
      'https://res.cloudinary.com/drvaemi9t/image/upload/v1657014452/person_1_hfwzdu.jpg',
    info: [
      {
        id: 'b6837c76-2c57-49e9-8574-2b5dd8dd0343', //Chhoti Bahen;
        duration: '3:47',
        ts: [{ start: '01:12', end: '01:16' }],
      },

      {
        id: '75cd7166-b438-4474-8314-717800bd0d17', //Chhoti Bahen;
        duration: '3:47',
        ts: [{ start: '01:12', end: '01:16' }],
      },
    ],
  },

  {
    image: 'Person 2',
    type: 'People',
    mainID: uuid(),
    AssetIds: [
      'b6837c76-2c57-49e9-8574-2b5dd8dd0343',
      '75cd7166-b438-4474-8314-717800bd0d17',
    ],
    imageSrc:
      'https://res.cloudinary.com/drvaemi9t/image/upload/v1657014452/person_2_q5hbvw.jpg',
    info: [
      {
        id: 'b6837c76-2c57-49e9-8574-2b5dd8dd0343', //Chhoti Bahen;
        duration: '3:47',
        ts: [{ start: '02:24', end: '02:43' }],
      },

      {
        id: '75cd7166-b438-4474-8314-717800bd0d17', //Chhoti Bahen;
        duration: '3:47',
        ts: [{ start: '02:24', end: '02:43' }],
      },
    ],
  },

  {
    image: 'Person 3',
    type: 'People',
    mainID: uuid(),
    AssetIds: [
      'b9580c20-4c77-46ff-88ca-9846ef9d8bf5',
      '84466189-6013-4b36-92cd-8b44f597c8fd',
    ],
    imageSrc:
      'https://res.cloudinary.com/drvaemi9t/image/upload/v1657014066/person_3_tgfrmn.jpg',
    info: [
      {
        id: 'b9580c20-4c77-46ff-88ca-9846ef9d8bf5', //Shaadi Ke baad;
        duration: '5:08',
        ts: [
          { start: '00:42', end: '00:45' },
          { start: '01:02', end: '01:04' },
          { start: '02:26', end: '02:28' },
        ],
      },

      {
        id: '84466189-6013-4b36-92cd-8b44f597c8fd', //Shaadi Ke baad;
        duration: '5:08',
        ts: [
          { start: '00:42', end: '00:45' },
          { start: '01:02', end: '01:04' },
          { start: '02:26', end: '02:28' },
        ],
      },
    ],
  },

  {
    image: 'Person 4',
    type: 'People',
    mainID: uuid(),
    AssetIds: [
      'b9580c20-4c77-46ff-88ca-9846ef9d8bf5',
      '84466189-6013-4b36-92cd-8b44f597c8fd',
    ],
    imageSrc:
      'https://res.cloudinary.com/drvaemi9t/image/upload/v1657014066/person_4_mml8jk.jpg',
    info: [
      {
        id: 'b9580c20-4c77-46ff-88ca-9846ef9d8bf5', //Shaadi Ke baad;
        duration: '5:08',
        ts: [
          { start: '02:28', end: '02:30' },
          { start: '03:04', end: '03:07' },
          { start: '03:36', end: '03:37' },
          { start: '04:07', end: '04:10' },
        ],
      },

      {
        id: '84466189-6013-4b36-92cd-8b44f597c8fd', //Shaadi Ke baad;
        duration: '5:08',
        ts: [
          { start: '02:28', end: '02:30' },
          { start: '03:04', end: '03:07' },
          { start: '03:36', end: '03:37' },
          { start: '04:07', end: '04:10' },
        ],
      },
    ],
  },

  {
    image: 'Suitcase',
    type: 'Object',
    mainID: uuid(),
    AssetIds: [
      'c8e9cdce-78c5-43c9-bf95-ef942e561278',
      'b6837c76-2c57-49e9-8574-2b5dd8dd0343',
      '75cd7166-b438-4474-8314-717800bd0d17',
    ],
    imageSrc: '/assets/user/stevie.jpg',
    info: [
      {
        id: 'c8e9cdce-78c5-43c9-bf95-ef942e561278', //Khilona;
        duration: '04:29',
        ts: [
          { start: '00:12', end: '00:18' },
          { start: '01:11', end: '01:14' },
          { start: '01:51', end: '01:53' },
          { start: '02:13', end: '02:23' },
        ],
      },
      {
        id: 'b6837c76-2c57-49e9-8574-2b5dd8dd0343', //Chhoti Bahen;
        duration: '3:47',
        ts: [{ start: '02:32', end: '02:42' }],
      },

      {
        id: '75cd7166-b438-4474-8314-717800bd0d17', //Chhoti Bahen;
        duration: '3:47',
        ts: [{ start: '02:32', end: '02:42' }],
      },
    ],
  },
  {
    image: 'swing',
    type: 'Object',
    mainID: uuid(),
    AssetIds: [
      'b9580c20-4c77-46ff-88ca-9846ef9d8bf5',
      '84466189-6013-4b36-92cd-8b44f597c8fd',
    ],
    imageSrc: '/assets/user/stevie.jpg',
    info: [
      {
        id: 'b9580c20-4c77-46ff-88ca-9846ef9d8bf5', //Shaadi Ke baad;
        duration: '5:08',
        ts: [
          { start: '00:34', end: '00:42' },
          { start: '00:49', end: '00:54' },
          { start: '01:10', end: '01:14' },
          { start: '01:41', end: '01:51' },
          { start: '02:05', end: '02:17' },
          { start: '02:22', end: '02:25' },
          { start: '02:31', end: '03:03' },
          { start: '03:07', end: '03:14' },
          { start: '03:29', end: '03:34' },
          { start: '03:37', end: '03:40' },
          { start: '03:59', end: '04:06' },
          { start: '04:12', end: '04:17' },
          { start: '04:43', end: '04:52' },
        ],
      },
      {
        id: '84466189-6013-4b36-92cd-8b44f597c8fd', //Shaadi Ke baad;
        duration: '5:08',
        ts: [
          { start: '00:34', end: '00:42' },
          { start: '00:49', end: '00:54' },
          { start: '01:10', end: '01:14' },
          { start: '01:41', end: '01:51' },
          { start: '02:05', end: '02:17' },
          { start: '02:22', end: '02:25' },
          { start: '02:31', end: '03:03' },
          { start: '03:07', end: '03:14' },
          { start: '03:29', end: '03:34' },
          { start: '03:37', end: '03:40' },
          { start: '03:59', end: '04:06' },
          { start: '04:12', end: '04:17' },
          { start: '04:43', end: '04:52' },
        ],
      },
    ],
  },

  {
    image: 'Table',
    type: 'Object',
    mainID: uuid(),
    AssetIds: [
      'cfdf128c-3ea6-4cab-a47b-f529c8b9887c',
      '502086d6-989a-4b9e-a40f-35d7efa33aaa',
      '6b7c9d0d-97a4-4c40-81ec-08c7235cb331',
      'dea37a6d-a712-42d6-8c6f-50f4c161ab16',
    ],
    imageSrc: '/assets/user/stevie.jpg',
    info: [
      {
        id: 'cfdf128c-3ea6-4cab-a47b-f529c8b9887c', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:17', end: '0:34' },
          { start: '00:42', end: '00:45' },
          { start: '00:57', end: '01:1' },
          { start: '01:03', end: '01:06' },
          { start: '01:23', end: '01:26' },
          { start: '01:31', end: '01:44' },
          { start: '03:28', end: '03:36' },
        ],
      },

      {
        id: '502086d6-989a-4b9e-a40f-35d7efa33aaa', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:17', end: '0:34' },
          { start: '00:42', end: '00:45' },
          { start: '00:57', end: '01:1' },
          { start: '01:03', end: '01:06' },
          { start: '01:23', end: '01:26' },
          { start: '01:31', end: '01:44' },
          { start: '03:28', end: '03:36' },
        ],
      },
      {
        id: '6b7c9d0d-97a4-4c40-81ec-08c7235cb331', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:17', end: '0:34' },
          { start: '00:42', end: '00:45' },
          { start: '00:57', end: '01:1' },
          { start: '01:03', end: '01:06' },
          { start: '01:23', end: '01:26' },
          { start: '01:31', end: '01:44' },
          { start: '03:28', end: '03:36' },
        ],
      },
      {
        id: 'dea37a6d-a712-42d6-8c6f-50f4c161ab16', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:17', end: '0:34' },
          { start: '00:42', end: '00:45' },
          { start: '00:57', end: '01:1' },
          { start: '01:03', end: '01:06' },
          { start: '01:23', end: '01:26' },
          { start: '01:31', end: '01:44' },
          { start: '03:28', end: '03:36' },
        ],
      },
    ],
  },
  {
    image: 'Glass',
    type: 'Object',
    mainID: uuid(),
    AssetIds: [
      'b9580c20-4c77-46ff-88ca-9846ef9d8bf5',
      '84466189-6013-4b36-92cd-8b44f597c8fd',
    ],
    imageSrc: '/assets/user/stevie.jpg',
    info: [
      {
        id: 'b9580c20-4c77-46ff-88ca-9846ef9d8bf5',
        duration: '5:08',
        ts: [
          { start: '00:31', end: '00:35' },
          { start: '00:36', end: '00:37' },
          { start: '00:38', end: '00:39' },
          { start: '00:40', end: '00:41' },
          { start: '00:42', end: '00:43' },
          { start: '01:05', end: '01:10' },
          { start: '02:18', end: '02:25' },
          { start: '03:39', end: '03:40' },
          { start: '04:05', end: '04:06' },
          { start: '04:12', end: '04:31' },
          { start: '04:37', end: '04:39' },
          { start: '04:44', end: '04:47' },
        ],
      },

      {
        id: '84466189-6013-4b36-92cd-8b44f597c8fd',
        duration: '5:08',
        ts: [
          { start: '00:31', end: '00:35' },
          { start: '00:36', end: '00:37' },
          { start: '00:38', end: '00:39' },
          { start: '00:40', end: '00:41' },
          { start: '00:42', end: '00:43' },
          { start: '01:05', end: '01:10' },
          { start: '02:18', end: '02:25' },
          { start: '03:39', end: '03:40' },
          { start: '04:05', end: '04:06' },
          { start: '04:12', end: '04:31' },
          { start: '04:37', end: '04:39' },
          { start: '04:44', end: '04:47' },
        ],
      },
    ],
  },

  {
    image: 'Tie',
    type: 'Object',
    mainID: uuid(),
    AssetIds: [
      'cfdf128c-3ea6-4cab-a47b-f529c8b9887c',
      '502086d6-989a-4b9e-a40f-35d7efa33aaa',
      '6b7c9d0d-97a4-4c40-81ec-08c7235cb331',
      'dea37a6d-a712-42d6-8c6f-50f4c161ab16',
    ],
    imageSrc: '/assets/user/stevie.jpg',
    info: [
      {
        id: 'cfdf128c-3ea6-4cab-a47b-f529c8b9887c', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:1', end: '0:36' },
          { start: '00:43', end: '00:57' },
          { start: '01:17', end: '01:18' },
          { start: '01:25', end: '01:59' },
          { start: '02:03', end: '02:08' },
          { start: '02:11', end: '02:31' },
          { start: '02:38', end: '03:36' },
        ],
      },

      {
        id: '502086d6-989a-4b9e-a40f-35d7efa33aaa', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:1', end: '0:36' },
          { start: '00:43', end: '00:57' },
          { start: '01:17', end: '01:18' },
          { start: '01:25', end: '01:59' },
          { start: '02:03', end: '02:08' },
          { start: '02:11', end: '02:31' },
          { start: '02:38', end: '03:36' },
        ],
      },
      {
        id: '6b7c9d0d-97a4-4c40-81ec-08c7235cb331', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:1', end: '0:36' },
          { start: '00:43', end: '00:57' },
          { start: '01:17', end: '01:18' },
          { start: '01:25', end: '01:59' },
          { start: '02:03', end: '02:08' },
          { start: '02:11', end: '02:31' },
          { start: '02:38', end: '03:36' },
        ],
      },
      {
        id: 'dea37a6d-a712-42d6-8c6f-50f4c161ab16', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:1', end: '0:36' },
          { start: '00:43', end: '00:57' },
          { start: '01:17', end: '01:18' },
          { start: '01:25', end: '01:59' },
          { start: '02:03', end: '02:08' },
          { start: '02:11', end: '02:31' },
          { start: '02:38', end: '03:36' },
        ],
      },
    ],
  },
  {
    image: 'chair',
    type: 'object',
    mainID: uuid(),
    AssetIds: [
      'c8e9cdce-78c5-43c9-bf95-ef942e561278',
      'cfdf128c-3ea6-4cab-a47b-f529c8b9887c',
      '502086d6-989a-4b9e-a40f-35d7efa33aaa',
      '6b7c9d0d-97a4-4c40-81ec-08c7235cb331',
      'dea37a6d-a712-42d6-8c6f-50f4c161ab16',
      'b6837c76-2c57-49e9-8574-2b5dd8dd0343',
      '75cd7166-b438-4474-8314-717800bd0d17',
    ],
    imageSrc: '/assets/user/stevie.jpg',
    info: [
      {
        id: 'c8e9cdce-78c5-43c9-bf95-ef942e561278', //Khilona;
        duration: '04:29',
        ts: [
          { start: '00:12', end: '00:18' },
          { start: '01:11', end: '01:14' },
          { start: '01:51', end: '01:53' },
          { start: '02:22', end: '02:25' },
          { start: '02:27', end: '02:32' },
          { start: '02:36', end: '02:39' },
        ],
      },
      {
        id: 'cfdf128c-3ea6-4cab-a47b-f529c8b9887c', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:31', end: '00:36' },
          { start: '00:45', end: '01:8' },
          { start: '01:11', end: '01:26' },
          { start: '01:31', end: '01:59' },
          { start: '02:3', end: '02:18' },
          { start: '02:34', end: '02:37' },
          { start: '02:46', end: '03:19' },
          { start: '03:21', end: '03:26' },
        ],
      },

      {
        id: '502086d6-989a-4b9e-a40f-35d7efa33aaa', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:31', end: '00:36' },
          { start: '00:45', end: '01:8' },
          { start: '01:11', end: '01:26' },
          { start: '01:31', end: '01:59' },
          { start: '02:3', end: '02:18' },
          { start: '02:34', end: '02:37' },
          { start: '02:46', end: '03:19' },
          { start: '03:21', end: '03:26' },
        ],
      },
      {
        id: '6b7c9d0d-97a4-4c40-81ec-08c7235cb331', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:31', end: '00:36' },
          { start: '00:45', end: '01:8' },
          { start: '01:11', end: '01:26' },
          { start: '01:31', end: '01:59' },
          { start: '02:3', end: '02:18' },
          { start: '02:34', end: '02:37' },
          { start: '02:46', end: '03:19' },
          { start: '03:21', end: '03:26' },
        ],
      },
      {
        id: 'dea37a6d-a712-42d6-8c6f-50f4c161ab16', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:31', end: '00:36' },
          { start: '00:45', end: '01:8' },
          { start: '01:11', end: '01:26' },
          { start: '01:31', end: '01:59' },
          { start: '02:3', end: '02:18' },
          { start: '02:34', end: '02:37' },
          { start: '02:46', end: '03:19' },
          { start: '03:21', end: '03:26' },
        ],
      },
      {
        id: 'b6837c76-2c57-49e9-8574-2b5dd8dd0343', //Chhoti Bahen;
        duration: '3:47',
        ts: [
          { start: '00:00', end: '00:3' },
          { start: '00:50', end: '00:55' },
          { start: '01:13', end: '01:16' },
          { start: '02:25', end: '02:31' },
          { start: '03:07', end: '03:20' },
        ],
      },

      {
        id: '75cd7166-b438-4474-8314-717800bd0d17', //Chhoti Bahen;
        duration: '3:47',
        ts: [
          { start: '00:00', end: '00:3' },
          { start: '00:50', end: '00:55' },
          { start: '01:13', end: '01:16' },
          { start: '02:25', end: '02:31' },
          { start: '03:07', end: '03:20' },
        ],
      },
    ],
  },

  {
    image: 'Plants',
    type: 'Object',
    mainID: uuid(),
    AssetIds: ['c8e9cdce-78c5-43c9-bf95-ef942e561278'],
    imageSrc: '/assets/user/stevie.jpg',
    info: [
      {
        id: 'c8e9cdce-78c5-43c9-bf95-ef942e561278', //Khilona;
        duration: '04:29',
        ts: [
          { start: '00:12', end: '00:18' },
          { start: '01:11', end: '01:17' },
          { start: '01:51', end: '01:53' },
          { start: '01:58', end: '02:01' },
          { start: '02:09', end: '02:10' },
          { start: '02:13', end: '02:30' },
          { start: '02:55', end: '03:08' },
          { start: '03:47', end: '03:51' },
          { start: '03:58', end: '04:00' },
          { start: '04:07', end: '04:13' },
        ],
      },
    ],
  },

  {
    image: 'Lamp',
    type: 'Object',
    mainID: uuid(),
    AssetIds: [
      'cfdf128c-3ea6-4cab-a47b-f529c8b9887c',
      '502086d6-989a-4b9e-a40f-35d7efa33aaa',
      '6b7c9d0d-97a4-4c40-81ec-08c7235cb331',
      'dea37a6d-a712-42d6-8c6f-50f4c161ab16',
      'b6837c76-2c57-49e9-8574-2b5dd8dd0343',
      '75cd7166-b438-4474-8314-717800bd0d17',
    ],
    imageSrc: '/assets/user/stevie.jpg',
    info: [
      {
        id: 'cfdf128c-3ea6-4cab-a47b-f529c8b9887c', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:1', end: '00:41' },
          { start: '00:44', end: '00:57' },
          { start: '01:00', end: '01:10' },
          { start: '01:11', end: '01:58' },
          { start: '02:00', end: '02:21' },
          { start: '02:38', end: '03:36' },
        ],
      },

      {
        id: '502086d6-989a-4b9e-a40f-35d7efa33aaa', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:1', end: '00:41' },
          { start: '00:44', end: '00:57' },
          { start: '01:00', end: '01:10' },
          { start: '01:11', end: '01:58' },
          { start: '02:00', end: '02:21' },
          { start: '02:38', end: '03:36' },
        ],
      },
      {
        id: '6b7c9d0d-97a4-4c40-81ec-08c7235cb331', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:1', end: '00:41' },
          { start: '00:44', end: '00:57' },
          { start: '01:00', end: '01:10' },
          { start: '01:11', end: '01:58' },
          { start: '02:00', end: '02:21' },
          { start: '02:38', end: '03:36' },
        ],
      },
      {
        id: 'dea37a6d-a712-42d6-8c6f-50f4c161ab16', //Jeena ki raah;
        duration: '3:37',
        ts: [
          { start: '00:1', end: '00:41' },
          { start: '00:44', end: '00:57' },
          { start: '01:00', end: '01:10' },
          { start: '01:11', end: '01:58' },
          { start: '02:00', end: '02:21' },
          { start: '02:38', end: '03:36' },
        ],
      },
      {
        id: 'b6837c76-2c57-49e9-8574-2b5dd8dd0343', //Chhoti Bahen;
        duration: '3:47',
        ts: [
          { start: '01:04', end: '01:12' },
          { start: '03:07', end: '03:20' },
        ],
      },

      {
        id: '75cd7166-b438-4474-8314-717800bd0d17', //Chhoti Bahen;
        duration: '3:47',
        ts: [
          { start: '01:04', end: '01:12' },
          { start: '03:07', end: '03:20' },
        ],
      },
    ],
  },
];
